export const team = {
  addMember: {
    team: '团队',
    seeHowToUse: '查看使用方法',
    help: '帮助',
    addAMember: '添加成员',
    addYourTeamMembersText: '将您的团队成员添加为支持代理，与机器人用户进行实时聊天。',
    name: '姓名',
    nameIsRequired: '姓名是必填项',
    email: '电子邮件',
    enterAValidEmail: '输入有效的电子邮件',
    password: '密码',
    passwordMustContain: '密码必须包含',
    atleast6Characters: '至少6个字符，',
    oneUpperCaseLetter: '1个大写字母',
    oneSpecialCharacter: '1个特殊字符*',
    profileIcon: '个人资料图标',
    whatsappNumber: 'WhatsApp号码',
    leadVisibility: '线索可见性*',
    addMember: '添加成员',
    role: '角色',
    createdOn: '创建时间',
    action: '操作',
    updateMember: '更新成员',
    add: '添加',
    cancel: '取消',
    selectVisibilityOption: '选择可见性选项',
    all: '全部',
    assigned: '已分配',
    nA: '不适用',
    admin: '管理员',
    agent: '代理',
    placeholders: {
      enterMemberName: '输入成员姓名',
      enterMemberEmailAddress: '输入成员电子邮件地址',
      createPasswordForMember: '为成员创建密码',
      searchCountry: '搜索国家',
      enterWhatsappNumber: '输入WhatsApp号码',
      selectLeadsVisibility: '选择线索可见性',
      searchTeamByNameOrEmail: '按姓名或电子邮件搜索团队成员',
    },
    modal: {
      deleteTeamMember: '删除团队成员',
      wantToDeleteThisTeamMember: '您确定要删除此团队成员吗？',
    },
    appTooltip: {
      clickToAddNewTeamMember: '单击添加新的团队成员',
      profileIconOfTeamMember: '团队成员的个人资料图标/图像',
      nameOfTeamMember: '团队成员的姓名',
      emailOfTeamMember: '团队成员的电子邮件',
      whatsappNumberOfTeamMember: '团队成员的WhatsApp号码',
      roleOfTeamMemberAsAdminOrAgent: '团队成员作为管理员/代理的角色',
      dateAndTimeOfCreatingTeamMemberRole: '创建团队成员角色的日期和时间',
      editOrDeleteTeamMember: '编辑/删除团队成员',
      editTeamMembersDetails: '编辑团队成员的详细信息。',
      removeAccessOfTeamMemberByDeletingAccount: '通过删除帐户来删除团队成员的访问权限',
    }
  },
  users: {
    manageMembers: '管理成员',
    managerMembersWhichCanAccessPanel: '管理可以访问您面板的合作伙伴团队',
    createNewMember: '创建新成员',
    createMember: '创建成员',
    updateMember: '更新成员',
    deleteTitleMember: '删除成员',
    deleteDescriptionMember: '您确定要删除此成员吗？',
    noMemberFound: '找不到成员！',
    titleMember: '创建成员',
    manageUsers: '管理用户',
    createNewUser: '创建新用户',
    managerUserWhichCanAccessPanel: '管理可以访问您面板的用户',
    phoneNumber: '电话号码',
    discard: '放弃',
    createUser: '创建用户',
    updateUser: '更新用户',
    noUserFOund: '找不到用户！',
    title: '创建用户',
    profileIcon: '个人资料图标*',
    name: '姓名*',
    email: '电子邮件*',
    password: '密码*',
    selectRole: '选择角色*',
    selectARole: '选择角色',
    selectLeadVisibility: '选择线索可见性*',
    confirmPassword: '确认密码*',
    tableHeadingName: '姓名',
    tableHeadingEmail: '电子邮件',
    tableHeadingPhoneNumber: '电话号码',
    tableHeadingRole: '角色',
    tableHeadingStatus: '状态',
    tableHeadingAction: '操作',
    deleteTitle: '删除用户',
    deleteDescription: '您确定要删除此用户吗？',
    placeholders: {
      searchHere: '在此处搜索',
      enterName: '输入姓名',
      enterEmail: '输入电子邮件',
      searchCountry: '搜索国家',
      enterPhoneNumber: '输入电话号码',
      enterPassword: '输入密码',
      enterConfirmPassword: '输入确认密码',
    },
    appTooltip: {
      TOOLTIP_DELETE_USERS: '删除用户',
      TOOLTIP_DELETE_MEMBERS: '删除成员',
    }
  },
  roles: {
    manageRoles: '管理角色',
    manageYourRoles: '管理您的角色。',
    name: '姓名*',
    description: '描述',
    discard: '放弃',
    createRole: '创建角色',
    creteARole: '创建角色',
    updateRole: '更新角色',
    noUserFound: '找不到用户角色！',
    assignPermissions: '分配权限*',
    tableHeadingName: '姓名',
    tableHeadingDescription: '描述',
    tableHeadingStatus: '状态',
    tableHeadingAction: '操作',
    module: '模块',
    read: '读取',
    write: '写入',
    remove: '删除',
    notes: '笔记',
    deleteTitle: '删除角色',
    deleteDescription: '注意：当您删除此角色时，将删除所有分配给该角色的用户。\n您确定要删除此角色吗？',
    deleteMemberDescription: '注意：当您删除此角色时，将删除所有分配给该角色的成员。\n您确定要删除此角色吗？',
    placeholders: {
      enterRoleName: '输入角色名称',
      searchHere: '在此处搜索',
      enterDescriptionForRole: '输入角色的描述',
    },
    appTooltip: {
      TOOLTIP_SECTION_TO_ALLOW_BLOCK: '允许或阻止用户访问的部分',
      TOOLTIP_CLICK_TO_ADD_ROLE: '单击以添加新角色',
    }
  },
  accessControl: {
    users: '用户',
    partnerTeam: '合作伙伴团队',
    members: '成员',
    roles: '角色',
  }
};
